import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/imgs/mima.png'


const _withScopeId = n => (_pushScopeId("data-v-2197c3ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "Your payment details will be encrypted securely by 128bit VeriSign SSL.")
], -1))

import { inject } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Payment',
  props: {
  paymentAmount: {
    type: String
  }
},
  setup(__props) {

const isMove = inject('isMove', false)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass({ payment: _unref(isMove), 'pc-payment': !_unref(isMove) })
  }, [
    _createElementVNode("h3", null, "Payment Amount：" + _toDisplayString(__props.paymentAmount), 1),
    _hoisted_1
  ], 2))
}
}

})